export enum FaultFieldTypeEnum {
  Label = 'label',
  TextArea = 'textarea',
  Text = 'text',
  Selection = 'selection',
  Switch = 'switch',
  Date = 'date',
  Number = 'number',
  Structure = 'structure',
  None = ''

}
